import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=a1fa21b2&scoped=true"
import script from "./Details.ts?vue&type=script&lang=ts&external"
export * from "./Details.ts?vue&type=script&lang=ts&external"
import style0 from "./Details.vue?vue&type=style&index=0&id=a1fa21b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fa21b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1fa21b2')) {
      api.createRecord('a1fa21b2', component.options)
    } else {
      api.reload('a1fa21b2', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=a1fa21b2&scoped=true", function () {
      api.rerender('a1fa21b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/pages/Details/Details.vue"
export default component.exports